module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/cover-image/cover-image.component.scss
// module id = ./src/app/modules/common-module/components/cover-image/cover-image.component.scss
// module chunks = 9